import React from 'react';

import { CardForm } from './styles';

const FormWrapper: React.FC = ({ children }) => {
  return <CardForm className="card shadow-sm my-3">{children}</CardForm>;
};

export default FormWrapper;
